import routerOptions0 from "/opt/simploshop/node_modules/.pnpm/nuxt@https+++pkg.pr.new+nuxt@32899_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+no_376380550bbae3aa60ac1d44b23ca449/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/simploshop/shared/core-theme/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}